import React from 'react';


interface CategoryFilterProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  selectedCategory,
  onCategoryChange,
}) => {
  return (
    <div className="flex flex-wrap gap-3">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`px-4 py-2 rounded-full font-body text-sm font-medium transition-all duration-300 ${
            selectedCategory === category
              ? 'bg-primary text-primary-foreground shadow-md scale-105'
              : 'bg-muted text-muted-foreground hover:bg-primary/20 hover:text-primary'
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;